import { Company } from '@shared-ikp/model/company.model';

export function concatCompanyNameAndGpNr(company: Company): string {
  return `${truncateLongName(company.name)}, ${company.gpNr}`;
}

function truncateLongName(name: string, maxLength = 30): string {
  if (name.length <= maxLength) {
    return name;
  }
  return name.slice(0, maxLength) + '...';
}
